import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class OrchestratorService {
  constructor(private router: Router) {}

  lFN_GetStateData() {
    return history.state;
  }
}
